<template>
  <div class="message">
    <van-row>
      <van-cell v-for="(item, index) in list" :key="index">
        <div class="oilList" :class="{ end: item.end_time <= 0 }">
          <div class="con">
            <p class="title">
              <span class="name">{{ item.advertising_name }}</span>
              <span class="time">{{ item.start_time }}</span>
            </p>
            <p class="ban">
              <img
                @click="Detail(item.href)"
                :src="item.img_url"
                @error="nofind()"
              />
              <span class="mask" v-if="item.end_time <= 0">活动已结束</span>
            </p>
          </div>
        </div>
      </van-cell>
    </van-row>
    <van-row class="empty" v-if="list.length == 0">
      <van-col class="emptyMsg" span="24">
        <img src="../../assets/member/nomessage.png" />
        <p class="tip1">暂无活动消息</p>
        <p class="tip2">返回上一级去逛逛吧</p>
        <p class="btn"><span @click="goBack()">上一级</span></p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import defaultImg from "@/assets/common/ListPreload.png";
export default {
  data() {
    return {
      list: [],
      msgId: 0,
    };
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.getInfo();
  },
  methods: {
    Detail(id) {
      this.msgId = id;
      if (this.msgId) {
        this.goToSeeActivityDetail();
      }
    },
    goToSeeActivityDetail() {
      this.params(this.msgId, this.msgId, "goToSeeActivityDetail");
    },
    getInfo() {
      //is_filtration_time备注：是否过滤时间 -1：不过滤 1：过滤（默认）
      this.$api
        .post("/adspace/index/get/ad/list", {
          labels: ["shallBuy_message_center_activity"],
        })
        .then((res) => {
          var current = Math.floor(new Date().getTime() / 1000);
          for (var i in res.shallBuy_message_center_activity) {
            var ts =
              this.date2timestamp(
                res.shallBuy_message_center_activity[i].end_time
              ) - current;
            res.shallBuy_message_center_activity[i].end_time = ts;
          }
          this.list = res.shallBuy_message_center_activity;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
      // this.$api.post("/activity/index/ad/get-data", {label: 'message_shull_buy_activity',is_filtration_time:-1}).then(res => {
      //     var current = Math.floor(new Date().getTime() / 1000);
      //     for(var i in res.adData){
      // 				var ts = this.date2timestamp(res.adData[i].end_time) - current;
      // 				res.adData[i].end_time = ts;
      //     }
      //     this.list = res.adData;
      // }).catch(err => {
      //     let keys = Object.keys(err);
      //  	let key = keys[0];
      // 	let message = err.message || err[key][0]
      // 	if(message.slice(0, 10) == 'timeout of') {
      // 		this.$toast('网络不给力，请稍候重试');
      // 	}else {
      // 		this.$toast(message);
      // 	}
      //     return;
      // });
    },
    goBack() {
      this.params("", "", "goBack");
    },
    nofind() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
  },
};
</script>
<style lang="less">
.message {
  padding: 0 12px;
  background: #f2f2f2;
  min-height: 100%;
  .empty {
    padding-top: 132px;
    .emptyMsg {
      padding: 0 47px;
      text-align: center;
      img {
        width: 100%;
        display: block;
      }
      .tip1 {
        color: #333;
        font-size: 13px;
        margin-top: 40px;
        height: 26px;
        line-height: 26px;
      }
      .tip2 {
        color: #666;
        font-size: 11px !important;
        height: 24px;
        line-height: 24px;
        margin-bottom: 23px;
      }
      .btn {
        text-align: center;
        span {
          width: 110px;
          height: 32px;
          line-height: 32px;
          color: #ff6059;
          display: inline-block;
          border: solid 1px #ff6059;
          border-radius: 16px;
          box-shadow: rgba(255, 96, 89, 0.14) 3px 0 6px;
        }
      }
    }
  }

  .van-cell {
    padding: 0;
    background: #f2f2f2;
    margin-bottom: 10px;
    .oilList {
      background: #f2f2f2;
      box-shadow: #e3e3e3 2px 0 4px;
      .con {
        background: #fff;
        padding: 0 12px 12px;
        border-radius: 10px;
        .title {
          color: #333;
          font-size: 13px;
          height: 42px;
          line-height: 42px;
          position: relative;
          padding-right: 120px;
          .name {
            width: 100%;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .time {
            float: right;
            font-size: 11px;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
        .ban {
          min-height: 120px;
          background: #f5f5f5;
          height: auto;
          position: relative;
          img {
            width: 100%;
            display: block;
          }
          .mask {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            color: #fff;
            font-size: 18px;
            text-align: center;
            box-sizing: border-box;
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.4);
          }
        }
        .describe {
          color: #666;
          font-size: 12px;
          line-height: 18px;
          padding: 12px 0 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
        }
      }
    }
    .end {
      .con {
        .title {
          color: #999;
        }
        .describe {
          color: #999;
        }
      }
    }
  }
  .van-cell:not(:last-child)::after {
    border: none;
  }
  .van-cell:nth-child(1) {
    .border {
      height: 20px;
    }
  }
}
</style>
